<template></template>

<script>
import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
import AuthenticationInterceptor from "../../components/core/authentication/AuthenticationInterceptor";
import PrefManager from "../../data/model/PrefManager";
import {RolesConstants} from "../../utils/RolesConstants";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";

export default {
  name: "ActivityRedirectToOffice",

  created() {
    if (
      !LoanScopeDataHolder.isOnboardingLoan() &&
      this.isAgent() &&
      AuthenticationInterceptor.getAuthorizationHeader() &&
      PrefManager.getUser()
    ) {
      document.body.className = "body-style";
      if(LoanScopeDataHolder.getLoanAccountNumber()){
        ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
      }else{
        ActivityNavigator.navigateTo(Activities.OFFICE);
      }
      
    }
  },

  methods : {
    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },
  }
};
</script>

<style scoped></style>